import React, { useState } from 'react'

import { InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'

import logoLight from '@assets/logo-color.png'
import logoDark from '@assets/logo-white.png'
import { CustomButton } from '@components/CustomButton'
import { useMockEnvironment } from '@contexts/mockEnv'
import { loginRequest } from '@services/msalConfig'

import {
  Container,
  Brand,
  ButtonContainer,
  Environment,
  Title,
  DebugButtonContainer,
} from './styles'

interface SignInProps {
  forceLoading?: boolean
}

export function SignIn({ forceLoading = false }: SignInProps) {
  const { instance, inProgress } = useMsal()
  const { setMockEnvironment } = useMockEnvironment()

  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches

  const isProduction = (import.meta.env.VITE_ENV_NAME || '').includes('PRODUCTION')
  const environment = (import.meta.env.VITE_ENV_NAME || '').toLocaleUpperCase()

  const [tapCount, setTapCount] = useState(0)

  const handleDebugTap = () => {
    setTapCount((prevCount) => prevCount + 1)
  }

  function openMockDataEnvironment() {
    setMockEnvironment(true)
  }

  function handleSignIn() {
    if (inProgress !== 'none') return
    instance.loginRedirect(loginRequest)
  }

  const isAuthenticating =
    forceLoading ||
    inProgress === InteractionStatus.Login ||
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Startup

  return (
    <Container>
      <Brand src={isDarkMode ? logoDark : logoLight} />
      <Title onClick={handleDebugTap}>Daily Work Schedule Next</Title>

      {!isProduction && <Environment>{environment}</Environment>}

      <ButtonContainer>
        <CustomButton isLoading={isAuthenticating} onPress={handleSignIn}>
          Sign In
        </CustomButton>
      </ButtonContainer>
      {tapCount > 5 && (
        <DebugButtonContainer>
          <CustomButton onPress={openMockDataEnvironment} secondary>
            Sign In Mocked Environment
          </CustomButton>
        </DebugButtonContainer>
      )}
    </Container>
  )
}
